module.exports = __webpack_public_path__ + "media/images/covid/traveling_safely_th-5011b0e443db3912aa2272c054fcf32c.jpg";